import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";

import useGetUsers from '../../api/users';
import { comparer } from '../../utils/comparer';
import { ROLE_PRIVILEGE } from '../../enums/roles';
import TagsSelect from "../../components/tags-select/tags-select.component";
import useFetch from "../../api/fetch";

export default function UserRow({ user, languageList, onCheck, isSelectAll }) {
    const { state, dispatch } = useContext(Context);
    const fetch = useFetch();

    const getUsers = useGetUsers();
    const [role, setRole] = useState('');
    const [language, setLanguage] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [email, setEmail] = useState(user.email);
    const [tags, setTags] = useState(false);
    const [tagsUpdate, setTagsUpdate] = useState(false);

    useEffect(() => {
        const opt = user.tags.map((tag) => {
            return {
                label: tag.name,
                value: tag.id
            }
        });
        setTags(opt);
        setTagsUpdate(opt);
        setRole(user.roles[0]);
        if (user.language) {
            setLanguage(user.language.tag);
        } else {
            setLanguage('');
        }
    }, [user]);

    const handleSave = async () => {
        const deletedTags = tagsUpdate.filter(comparer(tags));
        const addedTags = tags.filter(comparer(tagsUpdate));

        const mappedAddedTags = addedTags.map((t) => {
            let mapped = {
                name: t.label
            };
            if (!t.__isNew__) {
                mapped.id = t.value;
            }

            return mapped;
        });

        const mappedDeletedTags = deletedTags.map((t) => t.value);

        const formData = new FormData();
        formData.append('email', email);
        formData.append('role', role);
        formData.append('languageTag', language);
        formData.append('addedTags', JSON.stringify(mappedAddedTags));
        formData.append('deletedTags', mappedDeletedTags.toString());
        if (newPassword.length > 0) {
            formData.append('newPassword', newPassword);
        }

        const result = await fetch(`/api/user/update/${user.id}`, {
            method: "POST",
            body: formData
        }).then(x => x.json());
    }

    const handleToggleStatus = async (status) => {
        const ok = window.confirm(`Are you sure you want to ${status} this user?`);

        if (ok) {
            const formData = new FormData();
            formData.append('status', status);

            const result = await fetch(`/api/user/toggle-status/${user.id}`, {
                method: "POST",
                body: formData
            }).then(x => x.json());

            if (result.id) {
                const users = await getUsers();
                dispatch({ type: 'SET_USERS', users: users });
            }
        }
        
    }

    return (
        <tr className={`${user.deleted_at ? 'bg-light' : ''}`}>
            <td className='align-middle'><input type='checkbox' name='users' value={user.id} onChange={onCheck} /></td>
            <td className='align-middle'>{user.username}</td>
            <td className='align-middle'>
                <input type='text' className={"form-control shadow-none"} placeholder={"Email"} autoComplete={'false'} onChange={(e) => setEmail(e.target.value)} value={email} />
            </td>
            <td className='align-middle'>
                {user.roles ? <select className="custom-select" defaultValue={user.roles[0]} onChange={(e) => setRole(e.target.value)} value={role}>
                    {Object.entries(ROLE_PRIVILEGE).map(([key, value], index) => (
                        <option key={index} value={key}>{key}</option>
                    ))}
                </select> : ''}
            </td>
            <td className='align-middle'>
                {languageList ? <select className="custom-select" defaultValue={language} onChange={(e) => setLanguage(e.target.value)} value={language}>
                    {languageList.map((language, index) => (
                        <option key={index} value={language.tag}>{language.name}</option>
                    ))}
                </select> : ''}
            </td>
            <td className='align-middle'><TagsSelect selectedItems={tags} onChange={(values) => { setTags(values) }} /></td>
            <td className='align-middle'>
                <input type='password' className={"form-control shadow-none"} placeholder={"New password"} autoComplete={'false'} onChange={(e) => setNewPassword(e.target.value)} value={newPassword} />
            </td>
            <td className='align-middle'><button className='btn btn-mondly btn-blue' onClick={handleSave}>Save</button></td>
            <td className='align-middle'>
                <div className="dropleft">
                    <button className="btn btn-sm btn-icon-only text-muted" type="button" id={`optionsDropdown-${user.id}`} data-toggle="dropdown" aria-expanded="false">
                        <i className="fas fa-ellipsis-v"></i>
                    </button>
                    <div className="dropdown-menu" aria-labelledby={`optionsDropdown-${user.id}`}>
                        {user.deleted_at == null && <a className="dropdown-item" href="#" onClick={e => handleToggleStatus('deactivate')}>Deactivate user</a>}
                        {user.deleted_at != null && <a className="dropdown-item" href="#" onClick={e => handleToggleStatus('activate')}>Activate user</a>}
                    </div>
                </div>
            </td>
        </tr>
    )
}